module.exports = __webpack_public_path__ + "img/Thedarkkinght.05e9aa30.jpg";